import React from 'react';
import IconActionLinkTextLarge from './IconActionLinkTextLarge';
import IconActionLinkTextMedium from './IconActionLinkTextMedium';
import IconActionLinkTextSmall from './IconActionLinkTextSmall';

export default function IconActionLinkText({ size, ...props }) {
  switch (size) {
    case 'large':
      return <IconActionLinkTextLarge {...props} />;

    case 'medium':
      return <IconActionLinkTextMedium {...props} />;

    case 'small':
      return <IconActionLinkTextSmall {...props} />;

    default:
      return <IconActionLinkTextSmall {...props} />;
  }
}

IconActionLinkText.variations = {
  size: ['large', 'medium', 'small']
};
